<template>
  <div class="partner-resumes-base-interaction__table-row">
    <div class="partner-resumes-base-interaction__table-cell  _candidate">
      <div class="partner-resumes-base-interaction__table-cell-title  d-none  d-md-block">
        {{ $tResumesBaseInteraction('Candidate') }}
      </div>
      <APResumesBaseResumePageRowCandidate :resume="resume"/>
    </div>

    <div class="partner-resumes-base-interaction__table-cell  _stage">
      <div class="partner-resumes-base-interaction__table-cell-title  d-none  d-md-block">
        {{ $tResumesBaseInteraction('Interaction step') }}
      </div>
      <APResumesBaseInteractionsPageRowStage :resume="resume"/>
    </div>

    <div class="partner-resumes-base-interaction__table-cell  _step">
      {{ resume.step }}
    </div>


    <div class="partner-resumes-base-interaction__table-cell  _actions">
      <router-link-modified :to="{name: 'account-interaction', params: {id: resume.interaction_id}}"
                            class="partner-resumes-base-interaction__action-btn  base-btn  base-btn--outline-dark  base-btn--small">
        {{ $tResumesBaseInteraction('To interaction') }}
      </router-link-modified>
      <router-link-modified :to="{name: resumePageRouteName, params: {resumeId: resume.resume_id}}"
                            class="partner-resumes-base-interaction__action-btn  base-btn  base-btn--outline-dark  base-btn--small">
        <span class="d-lg-none  d-md-inline">{{ $tResumesBaseInteraction('See resume') }}</span>
        <span class="d-none  d-lg-inline  d-md-none">{{ $tResumesBaseInteraction('Resume') }}</span>
      </router-link-modified>
    </div>
  </div>
</template>

<script>
  import APResumesBaseResumePageRowCandidate
    from '@/components/partnerResumeBaseResumes/APResumesBaseResumePageRowCandidate'
  import APResumesBaseInteractionsPageRowStage
    from '@/components/partnerResumeBaseInteractions/APResumesBaseInteractionsPageRowStage'
  import {mapGetters} from 'vuex'

  export default {
    name: 'APResumesBaseInteractionsPageRow',
    components: {
      APResumesBaseInteractionsPageRowStage,
      APResumesBaseResumePageRowCandidate,
    },
    props: {
      resume: Object
    },
    data() {
      return {}
    },
    computed: {
      ...mapGetters('user', [
        'isPartner',
        'isModerator',
      ]),
      resumePageRouteName() {
        if (this.isPartner) {
          return 'account-partner-resumes-base-resume'
        }
        if (this.isModerator) {
          return 'account-moderator-candidates-resume'
        }

        //isAgent
        return 'account-agent-resumes-base-resume'
      }
    }
  }
</script>

<style lang="less">

</style>
